export default __webpack_public_path__ + "static/media/prismaIso.970f23bc.png";